import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Modal, Divider, Button, useSnackbar } from "@gemini/ui";
import { ContactInfos } from "../ContactInfos";
import { useContactingTestId, useTrackingViewCallback, useTrackingCallbackAnswered, } from "@/hooks";
import { useMobilePhonesSection, useContactContext } from "@/contexts/contact";
import { useI18n } from "@/contexts/i18n";
import { useEffect, useState } from "react";
export const RequestCallbackModal = ({ isOpen, setIsOpen, }) => {
    var _a;
    const { t } = useI18n();
    const { subtitle, title, logoUrl, isPrivateOwner } = (_a = useMobilePhonesSection()) !== null && _a !== void 0 ? _a : {};
    const { add: addSnackbar } = useSnackbar();
    const { toggleModal: toggleContactModal, triggerImageHeaderSection, resetImageHeaderSection, setDefaultMessage, } = useContactContext();
    const trackCallbackAnswered = useTrackingCallbackAnswered("request_callback");
    const [isModalOpen, setIsModalOpen] = useState(isOpen);
    const testId = useContactingTestId("MobilePhonesModal");
    useEffect(() => {
        setIsModalOpen(isOpen);
    }, [isOpen]);
    useTrackingViewCallback(isModalOpen);
    const toggleModal = () => {
        isModalOpen && resetImageHeaderSection();
        setIsModalOpen(!isModalOpen);
        setIsOpen(!isModalOpen);
    };
    const handleYesPress = () => {
        addSnackbar({
            variant: "success",
            description: t("contact.mobile_phones.callback_feedback_info"),
        });
        trackCallbackAnswered();
        resetImageHeaderSection();
        setIsModalOpen(false);
    };
    const handleNoPress = () => {
        setIsModalOpen(false);
        triggerImageHeaderSection();
        toggleContactModal({
            av_zone: "request_callback",
            legacyTrackingInfos: "detail-responsive",
        });
        setDefaultMessage(t("contact.form.callback_subject_placeholder"));
    };
    return (_jsxs(Modal, { testId: testId, title: t("contact.mobile_phones.title"), titleAs: "h2", trigger: () => null, isDismissable: true, isOpen: isModalOpen, onOpenChange: toggleModal, children: [_jsx(Divider, { "aria-hidden": "true", marginBottom: "spacing.24" }), _jsxs(Box, { children: [_jsx(ContactInfos, { testId: `${testId}.ContactInfos`, isPhysicalPerson: isPrivateOwner, title: title, subtitle: subtitle, logoUrl: logoUrl }), _jsx(Divider, { "aria-hidden": "true", marginVertical: "spacing.24" }), _jsx(Box, { width: "100%", textAlign: "center", marginBottom: "spacing.16", typography: "typography.headline.22.bold", children: t("contact.mobile_phones.callback_question") }), _jsx(Box, { width: "100%", textAlign: "center", marginBottom: "spacing.32", typography: "typography.body.16.regular", children: t("contact.mobile_phones.callback_question_explanation") }), _jsx(Button, { isFullWidth: true, variant: "primary", marginBottom: "spacing.8", onPress: handleYesPress, children: t("contact.mobile_phones.callback_answer_yes") }), _jsx(Button, { isFullWidth: true, variant: "secondary", onPress: handleNoPress, children: t("contact.mobile_phones.callback_answer_no") })] })] }));
};
